import React, { Fragment, useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Checkbox } from "primereact/checkbox";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { AlertContext } from "../../../context/AlertContext";
import { AuthContext } from "../../../context/AuthContext";
import Menu from "../Menu";
import Spinner from "../Spinner";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "../../../assets/css/DataTableDemo.css";
import { Navigate, useNavigate } from "react-router-dom";

export default function ProcesosBajasAutomaticas() {
  const [todasLasEmpresas, setTodasLasEmpresas] = useState(false);
  const [fechaSuspension, setFechaSuspension] = useState(
    new Date().toISOString().substring(0, 10),
  );
  const [afiliados, setAfiliados] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [motivoSuspension, setMotivoSuspension] = useState(null);
  const [procesando, setProcesando] = useState(false);

  const { mensajeAlerta } = useContext(AlertContext);
  const { state } = useContext(AuthContext);
  const {
    statusAcceso,
    empresaElegida,
    motivosSuspendidos,
    obtenerAcceso,
    obtenerMotivosSuspendidos,
    obtenerAfiliadosBajasAutomaticas,
    procesarBajasAutomaticas,
  } = useContext(ConfiguracionContext);

  let navigate = useNavigate();


  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ProcesosBajasAutomaticas",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerMotivosSuspendidos();
  }, []);

  const buscarAfiliados = async () => {
    if (!fechaSuspension) {
      mensajeAlerta(
        "Bajas Automáticas",
        "Debe indicar la fecha de suspensión.",
        "error",
      );
      return;
    }

    if (!todasLasEmpresas && (!empresaElegida || !empresaElegida.id)) {
      mensajeAlerta(
        "Bajas Automáticas",
        "Debe seleccionar una empresa.",
        "error",
      );
      return;
    }

    if (!motivoSuspension) {
      mensajeAlerta(
        "Bajas Automáticas",
        "Debe seleccionar un motivo de suspensión.",
        "error",
      );
      return;
    }

    setBuscando(true);
    const resultado = await obtenerAfiliadosBajasAutomaticas({
      todasLasEmpresas,
      empresaId: todasLasEmpresas ? null : empresaElegida.id,
      motivoSuspendido: motivoSuspension,
    });
    setAfiliados(resultado);
    setBuscando(false);
  };

  const exitClick = (e) => {
    navigate("/");
  };

    const accesoDenegado = () => {
    mensajeAlerta(
      "Proceso de Impresión",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };


  const ejecutarProceso = async () => {
    setProcesando(true);
    const resultado = await procesarBajasAutomaticas({
      todasLasEmpresas,
      empresaId: todasLasEmpresas ? null : empresaElegida.id,
      fechaSuspension,
      motivoSuspendido: motivoSuspension,
    });
    setProcesando(false);

    if (resultado) {
      mensajeAlerta("Bajas Automáticas", resultado.message, "success");
      setAfiliados([]);
    }
  };

  const iniciarProceso = () => {
    if (!afiliados.length) {
      mensajeAlerta(
        "Bajas Automáticas",
        "Primero debe buscar los afiliados a suspender.",
        "error",
      );
      return;
    }

    if (!fechaSuspension || !motivoSuspension) {
      mensajeAlerta(
        "Bajas Automáticas",
        "Debe indicar la fecha y el motivo de suspensión.",
        "error",
      );
      return;
    }

    if (!todasLasEmpresas && (!empresaElegida || !empresaElegida.id)) {
      mensajeAlerta(
        "Bajas Automáticas",
        "Debe seleccionar una empresa.",
        "error",
      );
      return;
    }

    confirmDialog({
      message: `¿Está seguro de iniciar el proceso para suspender ${afiliados.length} afiliados?`,
      header: "Confirmación",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-success",
      rejectClassName: "p-button-secondary",
      closable: false,
      acceptLabel: "Sí",
      rejectLabel: "No",
      accept: ejecutarProceso,
    });
  };
  const generarPdf = () => {
    if (!afiliados.length) {
      mensajeAlerta(
        "Bajas Automáticas",
        "No hay afiliados para incluir en el PDF.",
        "error",
      );
      return;
    }

    const doc = new jsPDF("landscape");
    doc.setFontSize(16);
    doc.text("Bajas Automáticas", 14, 15);
    doc.setFontSize(10);
    doc.text(`Fecha de suspensión: ${fechaSuspension}`, 14, 22);
    doc.text(
      `Motivo: ${motivoSuspension ? motivoSuspension.nombre : ""}`,
      14,
      28,
    );

    autoTable(doc, {
      startY: 34,
      head: [[
        "Nº afiliado",
        "Nombre/Razón social",
        "Grupo",
        "Empresa",
        "Cuotas impagas",
      ]],
      body: afiliados.map((afiliado) => [
        afiliado.id_titular,
        afiliado.nombre_razonsocial,
        afiliado.nombre_grupo,
        afiliado.nombre_empresa,
        afiliado.cuotas_impagas,
      ]),
      styles: { fontSize: 9 },
      headStyles: { fillColor: [40, 116, 166] },
    });

    doc.save(`bajas-automaticas-${fechaSuspension}.pdf`);
  };

  return (
    <Fragment>
      <Menu />
      <ConfirmDialog />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <div style={{ padding: "1.5rem" }}>
          <Tag value="Bajas Automáticas" />
          <p style={{ maxWidth: "850px", fontWeight: 600 }}>
            Este proceso suspenderá hasta la fecha indicada a los Afiliados
            mensuales de los grupos abonados comunes, áreas protegidas y
            colegios que deban 2 o más cuotas enteras salvo los que tengan
            marcado Facturación Manual.
          </p>

          <Grid
            container
            spacing={3}
            alignItems="center"
            style={{ marginTop: "0.5rem" }}
          >
            <Grid item xs={12} md={4}>
              <label htmlFor="fechaSuspension">Fecha de suspensión</label>
              <input
                id="fechaSuspension"
                type="date"
                value={fechaSuspension}
                onChange={(event) => setFechaSuspension(event.target.value)}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "0.65rem",
                  marginTop: "0.4rem",
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Autocomplete
                fullWidth
                options={
                  motivosSuspendidos
                    ? motivosSuspendidos.filter((item) => item.habilitado)
                    : []
                }
                value={motivoSuspension}
                getOptionLabel={(option) => option.nombre || ""}
                noOptionsText="No hay motivos disponibles"
                onChange={(event, value) => setMotivoSuspension(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Motivo de suspensión *"
                    variant="standard"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.65rem",
                }}
              >
                <Checkbox
                  inputId="todasLasEmpresas"
                  checked={todasLasEmpresas}
                  onChange={(event) => setTodasLasEmpresas(event.checked)}
                />
                <label htmlFor="todasLasEmpresas">Todas las empresas</label>
              </div>
              {!todasLasEmpresas && empresaElegida ? (
                <small>Empresa seleccionada: {empresaElegida.nombre}</small>
              ) : null}
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              style={{ display: "flex", gap: "0.75rem" }}
            >
              <Button
                variant="contained"
                color="success"
                startIcon={<SearchIcon />}
                onClick={buscarAfiliados}
                disabled={buscando}
              >
                {buscando ? "Buscando..." : "Buscar"}
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<PlayArrowIcon />}
                onClick={iniciarProceso}
                disabled={!afiliados.length || procesando || buscando}
              >
                {procesando ? "Procesando..." : "Iniciar proceso"}
              </Button>
              <Button
                variant="outlined"
                color="error"
                startIcon={<CloseIcon />}
                href="/"
              >
                Salir
              </Button>
            </Grid>
          </Grid>

          <div style={{ marginTop: "2rem" }}>
            <Button
              variant="contained"
              color="error"
              startIcon={<PictureAsPdfIcon />}
              onClick={generarPdf}
              disabled={!afiliados.length}
              style={{ marginRight: "0.75rem" }}
            >
              Generar PDF
            </Button>
            <Tag
              value={`${afiliados.length} afiliado(s) encontrado(s)`}
              severity="info"
            />
            <DataTable
              value={afiliados}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              emptyMessage="No hay afiliados que cumplan las condiciones."
              responsiveLayout="scroll"
              style={{ marginTop: "0.75rem" }}
            >
              <Column field="id_titular" header="Nº afiliado" sortable />
              <Column
                field="nombre_razonsocial"
                header="Nombre/Razón social"
                sortable
              />
              <Column field="nombre_grupo" header="Grupo" sortable />
              <Column field="nombre_empresa" header="Empresa" sortable />
              <Column
                field="cuotas_impagas"
                header="Cuotas impagas"
                sortable
              />
            </DataTable>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
}